<!-- <p-gmap [options]="options" [overlays]="overlays" [style]="{'width':'100%','height':'320px'}"
            (onMapClick)="handleMapClick($event)" (onOverlayClick)="handleOverlayClick($event)"></p-gmap> -->
<div
  class="innerBanner"
  (click)="imageClick(0)"
  style="background-image: url('../../assets/images/home-banner-2.avif')"
>
  <!-- inner banner-->
  <div class="bannerText">
    <h1>{{ 'MAPS' | translate }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <app-breadcrumb></app-breadcrumb> -->
<app-breadcrumb-row></app-breadcrumb-row>
<div class="maps">
  <div class="row m-0">
    <div class="col-md-4">
      <p-accordion class="categoryList">
        <p-accordionTab header="{{ 'Category' | translate }}">
          <ul>
            <li *ngFor="let category of categoryTypes; let i = index">
              <p-checkbox class="pcheck" (click)="selectCategeory(category.id)"> </p-checkbox
              ><span>{{ category.name }}</span>
            </li>
          </ul>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col-md-8">
      <p-gmap
        #gmap
        [options]="options"
        [overlays]="overlays"
        [style]="{ width: '100%', height: '388px' }"
        (onOverlayClick)="handleOverlayClick($event)"
        class="mapsDisplay"
      ></p-gmap>
    </div>
  </div>
</div>
